export { default } from './createStyles';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/styles/esm/createStyles/index.js
// module id = 847
// module chunks = 121